import { LocalStorageKeys } from "@/types/local-storage.types";

const LOCAL_STORAGE: Record<LocalStorageKeys, LocalStorageKeys> = {
  accessTokenKey: "accessTokenKey",
  lang: "lang",
  overduePlanBannerClosed: "overduePlanBannerClosed",
  pendingPaymentBannerClosed: "pendingPaymentBannerClosed",
  biometricCredentialId: "biometricCredentialId",
  biometricEnabled: "biometricEnabled",
  pushNotificationsEnabled: "pushNotificationsEnabled",
  refreshTokenKey: "refreshTokenKey",
};

export default LOCAL_STORAGE;
